import React from "react";
import moment from "moment";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    Typography,
    Grid,
    Card,
    Divider,
    CardContent,
    IconButton,
    Avatar,
} from "@mui/material";
import { RxCross2 } from "react-icons/rx";

const ViewWarehousing = (props) => {
    const { open, handleClose, rowData, isLoading } = props;

    const labelStyle = {
        fontSize: "14px",
        color: "#6b7280",
        display: "flex",
        alignItems: "center",
        gap: "4px",
        mb: 0.5,
    };

    const valueStyle = {
        fontSize: "15px",
        color: "#111827",
        fontWeight: 500,
        mb: 2,
    };

    const getAvatarColor = (text) => {
        const colors = ["#1976D2", "#388E3C", "#F57C00", "#7B1FA2", "#0288D1", "#C2185B"];
        const index = text ? text.charCodeAt(0) % colors.length : 0;
        return colors[index];
    };

    const formatCurrency = (value) => {
        if (value === null || value === undefined || value === "") return "N/A";
        const num = Number(value);
        if (isNaN(num)) return value;
        return `₹${num.toLocaleString("en-IN")}`;
    };

    const formatDate = (value) => {
        if (!value) return "N/A";
        const date = moment.utc(value);
        if (date.isValid()) return date.format("DD MMM YYYY");
        return value;
    };

    const renderValue = (field, value) => {
        if (value === null || value === undefined || value === "") return "N/A";
        if (field === "uwLCD" || field === "uwRCD" || field === "actLCD" || field === "actRCD") {
            return formatDate(value);
        }
        if (
            field === "uwPlinthAreaSqFt" || field === "actPlinthAreaSqFt" ||
            field === "uwLeaseTenureMonths" || field === "actLeaseTenureMonths" ||
            field === "uwRentFreeMonths" || field === "actRentFreeMonths" ||
            field === "actLockInMonths"
        ) {
            const num = Number(value);
            return isNaN(num) ? value : num.toLocaleString("en-IN");
        }
        if (
            field === "uwRentalPerSqFt" || field === "uwCAMPerSqFt" || field === "actTIRentalPerSqFt" ||
            field === "netEffectiveRental" || field === "actCAMPerSqFt" || field === "adjustedUnderwritingRental" ||
            field === "actNetEffectiveRentalPerSqFt" || field === "difference" || field === "uwEscalation" || field === "actEscalation"
        ) {
            return formatCurrency(value);
        }
        return value;
    };

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: {
                    borderTopLeftRadius: "5px",
                    borderTopRightRadius: "5px",
                    backgroundColor: "#FFFFFF",
                    width: "100%",
                    overflowX: "hidden"
                },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
                position: "relative",
            }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Typography sx={{
                        fontWeight: 600,
                        fontSize: "27px",
                        lineHeight: "100%",
                        color: "#140F36",
                        fontFamily: "Outfit, sans-serif"
                    }}>
                        View Warehousing Details
                    </Typography>
                </Box>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 50,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <Card
                    elevation={0}
                    sx={{
                        borderRadius: "3px",
                        border: "1px solid #e5e7eb",
                        backgroundColor: "#fff",
                        p: 2,
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 1,
                        }}
                    >
                        <Typography sx={{
                            fontWeight: 600,
                            fontSize: "20px",
                            fontFamily: "Outfit, sans-serif",
                            color: "#0A0A0C"
                        }}>
                            Warehousing Information
                        </Typography>
                    </Box>

                    <Divider sx={{ mb: 3 }} />

                    <CardContent sx={{ pt: 0 }}>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12 }}>
                                <Grid container spacing={1}>
                                    {/* Basic Info */}
                                    {/* <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>ID:</strong>
                                        </Typography>
                                        <Box sx={{ display: "flex", alignItems: 'center', gap: 1, mb: 2, p: 0 }}>
                                            <Avatar
                                                sx={{
                                                    width: 30,
                                                    height: 30,
                                                    bgcolor: getAvatarColor(rowData?.customId || ""),
                                                    color: "#fff",
                                                    fontSize: "14px",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                {rowData?.customId?.[0] || "W"}
                                            </Avatar>
                                            <Typography sx={valueStyle}>
                                                {rowData?.customId ?? "N/A"}
                                            </Typography>
                                        </Box>
                                    </Grid> */}

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Product:</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {rowData?.product ?? "N/A"}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Project:</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {rowData?.project ?? "N/A"}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Warehouse Name:</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {rowData?.warehouseName ?? "N/A"}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Status:</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {rowData?.status ?? "N/A"}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Tenant Name:</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {rowData?.tenantName ?? "N/A"}
                                        </Typography>
                                    </Grid>

                                    {/* Underwriting Section */}
                                    <Grid size={{ xs: 12 }}>
                                        <Typography sx={{ ...labelStyle, fontWeight: 600, mt: 1 }}>
                                            Underwriting
                                        </Typography>
                                        <Divider sx={{ mb: 2 }} />
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Plinth Area Sqft:</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {renderValue("uwPlinthAreaSqFt", rowData?.uwPlinthAreaSqFt)}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>LCD:</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {renderValue("uwLCD", rowData?.uwLCD)}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>RCD:</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {renderValue("uwRCD", rowData?.uwRCD)}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Lease Tenure (Months):</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {renderValue("uwLeaseTenureMonths", rowData?.uwLeaseTenureMonths)}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Rent Free (Months):</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {renderValue("uwRentFreeMonths", rowData?.uwRentFreeMonths)}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Rental INR Psf PM On Plinth Excl CAM Excl TI:</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {renderValue("uwRentalPerSqFt", rowData?.uwRentalPerSqFt)}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>CAM INR Psf PM On Plinth:</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {renderValue("uwCAMPerSqFt", rowData?.uwCAMPerSqFt)}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Escalation (%):</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {renderValue("uwEscalation", rowData?.uwEscalation)}
                                        </Typography>
                                    </Grid>

                                    {/* Actuals Section */}
                                    <Grid size={{ xs: 12 }}>
                                        <Typography sx={{ ...labelStyle, fontWeight: 600, mt: 1 }}>
                                            Actuals
                                        </Typography>
                                        <Divider sx={{ mb: 2 }} />
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Plinth Area Sqft (Actual):</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {renderValue("actPlinthAreaSqFt", rowData?.actPlinthAreaSqFt)}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>LCD (Actual):</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {renderValue("actLCD", rowData?.actLCD)}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>RCD (Actual):</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {renderValue("actRCD", rowData?.actRCD)}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Lock-In (Months):</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {renderValue("actLockInMonths", rowData?.actLockInMonths)}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>TI Rental INR Psf PM:</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {renderValue("actTIRentalPerSqFt", rowData?.actTIRentalPerSqFt)}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Net Effective Rental INR Psf PM On Plinth Excl CAM Excl TI:</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {renderValue("actNetEffectiveRentalPerSqFt", rowData?.actNetEffectiveRentalPerSqFt)}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Lease Tenure Months (Actual):</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {renderValue("actLeaseTenureMonths", rowData?.actLeaseTenureMonths)}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Rent Free Months (Actual):</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {renderValue("actRentFreeMonths", rowData?.actRentFreeMonths)}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>CAM INR Psf PM On Plinth (Actual):</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {renderValue("actCAMPerSqFt", rowData?.actCAMPerSqFt)}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Escalation Actual(%):</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {renderValue("actEscalation", rowData?.actEscalation)}
                                        </Typography>
                                    </Grid>

                                    {/* Rental Comparison Section */}
                                    <Grid size={{ xs: 12 }}>
                                        <Typography sx={{ ...labelStyle, fontWeight: 600, mt: 1 }}>
                                            Rental Comparison
                                        </Typography>
                                        <Divider sx={{ mb: 2 }} />
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Adjusted Underwriting Rental:</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {renderValue("adjustedUnderwritingRental", rowData?.adjustedUnderwritingRental)}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Net Effective Rental INR Psf PM On Plinth Excl CAM Excl TI (Rental):</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {renderValue("netEffectiveRental", rowData?.netEffectiveRental)}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Difference:</strong>
                                        </Typography>
                                        <Typography sx={{
                                            ...valueStyle,
                                            color: rowData?.difference && Number(rowData.difference) < 0 ? "#d32f2f" : "#2e7d32"
                                        }}>
                                            {renderValue("difference", rowData?.difference)}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </DialogContent>
        </Dialog>
    );
};

export default ViewWarehousing;